<template>
  <div>
    <ListagemVueComponenteMenuComponent />
  </div>
</template>

<script>

import ListagemVueComponenteMenuComponent from '../components/ListagemVueComponenteMenuComponent.vue'

export default {
  components: { ListagemVueComponenteMenuComponent },
  name: 'VueComponenteMenuPage',
 
}
</script>
